export const formatWalletAccount = (walletAccount: string): string => {
  return walletAccount
    ? `${walletAccount.slice(0, 6)}...${walletAccount.slice(-4)}`
    : ''
}
